import { LATITUDE_LIMIT, LONGITUDE_LIMIT, readCoord } from '../../shared/utils/coords';
import { isRecord, toId, toText } from '../../shared/utils/parse';
import type { Address, AddressDraft } from '../models/address/address.model';

/** Тело `POST /address`: имена полей серверные, `street` уезжает как `address`. */
export interface AddressPayload {
  address: string;
  latitude: number;
  longitude: number;
  apartment: string | null;
  landmark: string | null;
}

/** null — запись непригодна: модель требует координаты, а без строки адреса её нечем подписать. */
export function mapAddress(raw: unknown): Address | null {
  if (!isRecord(raw)) {
    return null;
  }
  const id = toId(raw['id']);
  const street = toText(raw['address']);
  const latitude = readCoord(raw['latitude'], LATITUDE_LIMIT);
  const longitude = readCoord(raw['longitude'], LONGITUDE_LIMIT);
  if (id === null || street === null || latitude === null || longitude === null) {
    return null;
  }
  return {
    id,
    street,
    apartment: toText(raw['apartment']),
    landmark: toText(raw['landmark']),
    latitude,
    longitude,
  };
}

/** Ответ — Spring `Page`; непригодная запись выбрасывается из списка, а не «чинится» нулями. */
export function mapAddresses(raw: unknown): Address[] {
  const content: unknown = isRecord(raw) ? raw['content'] : undefined;
  if (!Array.isArray(content)) {
    return [];
  }
  const entries: unknown[] = content;
  const addresses: Address[] = [];
  for (const entry of entries) {
    const address = mapAddress(entry);
    if (address !== null) {
      addresses.push(address);
    }
  }
  return addresses;
}

export function toAddressPayload(draft: AddressDraft): AddressPayload {
  return {
    address: draft.street,
    latitude: draft.latitude,
    longitude: draft.longitude,
    // Пустую строку сервер сохранит как значение — «квартиры нет» обязано уехать как null.
    apartment: toText(draft.apartment),
    landmark: toText(draft.landmark),
  };
}
